// extracted by mini-css-extract-plugin
module.exports = {"home":"TaskListPage-styles-module--home--3XDnJ"};